import ContactFormConfiguration from "../models/ContactFormConfiguration";
import ContactFormSubjectMapper from "./ContactFormSubject.mapper";

export default class ContactFormConfigurationMapper {
    public map(data: any): ContactFormConfiguration {
        const configuration: ContactFormConfiguration = new ContactFormConfiguration();
        configuration.questionTitle = data.QuestionTitle;
        configuration.questionDescription = data.QuestionDescription;
        configuration.informationTitle = data.InformationTitle;
        configuration.informationDescription = data.InformationDescription;
        configuration.subjectLabel = data.SubjectLabel;
        configuration.subjectPlaceholder = data.SubjectPlaceholder;
        configuration.questionLabel = data.QuestionLabel;
        configuration.questionPlaceholder = data.QuestionPlaceholder;
        configuration.attachmentToLargeValidationMessage = data.AttachmentToLargeValidationMessage;
        configuration.attachmentLabel = data.AttachmentLabel;
        configuration.attachmentExtraInfo = data.AttachmentExtraInfo;
        configuration.attachmentAddFileLabel = data.AttachmentAddFileLabel;
        configuration.attachmentDragFileLabel = data.AttachmentDragFileLabel;
        configuration.alreadyCustomerButton = data.AlreadyCustomerButton;
        configuration.notYetCustomerButton = data.NotYetCustomerButton;
        configuration.rszNumberLabel = data.RszNumberLabel;
        configuration.rszNumberPlaceholder = data.RszNumberPlaceholder;
        configuration.rszNumberInfo = data.RszNumberInfo;
        configuration.rszNumberFindPictureButtonText = data.RszNumberFindPictureButtonText;
        configuration.rszNumberFindPictureUrl = data.RszNumberFindPictureUrl;
        configuration.customerNumberLabel = data.CustomerNumberLabel;
        configuration.customerNumberPlaceholder = data.CustomerNumberPlaceholder;
        configuration.customerNumberAdditionalInformation = data.CustomerNumberAdditionalInformation;
        configuration.dayOfBirthLabel = data.DayOfBirthLabel;
        configuration.dayOfBirthPlaceholder = data.DayOfBirthPlaceholder;
        configuration.genderLabel = data.GenderLabel;
        configuration.genderValues = data.GenderValues;
        configuration.firstnameLabel = data.FirstnameLabel;
        configuration.firstnamePlaceholder = data.FirstnamePlaceholder;
        configuration.lastnameLabel = data.LastnameLabel;
        configuration.lastnamePlaceholder = data.LastnamePlaceholder;
        configuration.emailLabel = data.EmailLabel;
        configuration.emailPlaceholder = data.EmailPlaceholder;
        configuration.telephoneLabel = data.TelephoneLabel;
        configuration.telephonePlaceholder = data.TelephonePlaceholder;
        configuration.postalCodeLabel = data.PostalCodeLabel;
        configuration.postalCodePlaceholder = data.PostalCodePlaceholder;
        configuration.consentLabel = data.ConsentLabel;
        configuration.sendButton = data.SendButton;
        configuration.redirectPageURL = data.RedirectPageURL;
        configuration.privacyPageURL = data.PrivacyPageURL;
        configuration.privacyPageLabel = data.PrivacyPageLabel;
        configuration.fileUploadAllowedFormatsLabel = data.FileUploadAllowedFormatsLabel;

        configuration.subjects = data.Subjects.map((sub: any) => { return new ContactFormSubjectMapper().map(sub)} );

        return configuration;
    }

}